import React, { PureComponent } from 'react';
import { injectIntl, intlShape } from 'react-intl';

import styles from './styles';
import messages from './messages';

class Footer extends PureComponent {
  render() {
    const { intl } = this.props;

    return (
      <div style={styles.wrapper}>
        <i aria-hidden="true" style={styles.icon} />
        <span style={styles.branding}>{intl.formatMessage(messages.footer_brand)}</span>
      </div>
    );
  }
}

Footer.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(Footer);
